/** Enum which specifies the notification Type
 * Reference : https://outlookweb.visualstudio.com/Outlook%20Web/_git/server-ows-api?path=%2Fsrc%2FMicrosoft.OWS.ActivityFeed%2FModels%2FActivityType.cs&_a=contents&version=GBmaster
 */
export enum ActivityType {
    Reactions = 'Reactions',
    WhatsNew = 'WhatsNew',
}
